export const ActionTypes = {
  DATA_RECEIVED: 'DATA_RECEIVED',

  // navigation
  CLICK_EXPERT_REVIEWS_ACCORDION: 'CLICK_EXPERT_REVIEWS_ACCORDION',
  CLICK_EXPERT_RATINGS_ACCORDION: 'CLICK_EXPERT_RATINGS_ACCORDION',
  CLICK_CONSUMER_REVIEWS_ACCORDION: 'CLICK_CONSUMER_REVIEWS_ACCORDION',
  CLICK_CONSUMER_RATINGS_ACCORDION: 'CLICK_CONSUMER_RATINGS_ACCORDION',
  CLICK_AWARDS_ACCORDION: 'CLICK_AWARDS_ACCORDION',

  // awards
  CLICK_AWARDS_INFO: 'CLICK_AWARDS_INFO',

  // expert reviews
  CLICK_EXPERT_REVIEWS_READ_MORE: 'CLICK_EXPERT_REVIEWS_READ_MORE',


  // consumer reviews
  CLICK_CONSUMER_REVIEWS_READ_MORE: 'CLICK_CONSUMER_REVIEWS_READ_MORE',
  CLICK_CONSUMER_REVIEWS_MORE_REVIEWS: 'CLICK_CONSUMER_REVIEWS_MORE_REVIEWS',

  // footer
  CLICK_FOOTER_PRIVACY_LINK: 'CLICK_FOOTER_PRIVACY_LINK',
  CLICK_FOOTER_READ_MORE: 'CLICK_FOOTER_READ_MORE',

  // global overlay
  OPEN_GLOBAL_OVERLAY: 'OPEN_GLOBAL_OVERLAY',
  CLOSE_GLOBAL_OVERLAY: 'CLOSE_GLOBAL_OVERLAY'
};

export default ActionTypes;
